import type { Article } from '../api/types';

/**
 * Renders the server-produced <c>renderedHtml</c> into the
 * <c>.article-prose</c> typography surface.
 *
 * <para><b>Security posture</b>: <c>dangerouslySetInnerHTML</c> is safe
 * here because the source HTML passes through the server-side
 * <c>ArticleHtmlSanitizer</c> on every save - the allow-list strips any
 * tag / attribute / scheme outside the editorial whitelist (no
 * <c>&lt;script&gt;</c>, no <c>on*</c> attrs, no <c>javascript:</c>
 * hrefs, no inline styles). No client-side sanitisation needed.</para>
 *
 * <para>If the renderer ever changes shape (e.g. emits component
 * placeholders the SPA hydrates), this is the seam where that transition
 * lives - pure-HTML pass-through today; future versions can return
 * Preact nodes from a server-supplied JSON tree instead.</para>
 */
export function ArticleBody({ article }: { article: Article }) {
    const html = article.renderedHtml ?? '';
    return <div class="article-prose" dangerouslySetInnerHTML={{ __html: html }} />;
}
